import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ProductModel, ProductCollectionModel } from '@/libs/Api';
import { ProductsDataService } from '@/libs/products/products-data-service';
import { ProductCollectionsDataService } from '@/libs/products/product-collections-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const productsStore = registerCrudStore<ProductModel, ProductModel>(BusinessModule.Product, new ProductsDataService());
export const productCollectionsStore = registerCrudStore<ProductCollectionModel, ProductCollectionModel>(
    BusinessModule.ProductCollection,
    new ProductCollectionsDataService()
);
